import * as R from 'ramda'
import store from '@/store'

export const beforeEach = async (to, from, next) => {
  const { auth = true } = to.meta
  const { auth: { info }, app: { companyInfo } } = store.state

  if (to.path === '/account/license') {
    /* if (store.state.auth.auth.user_id !== 'a24ad2bb6e37465089858eb4df85a072') {
      return next('/')
    } */
    document.title = info.displayname
  } else {
    document.title = companyInfo.name || 'OneCloud'
  }
  if ((R.isNil(store.state.app.level) || R.isEmpty(store.state.app.level)) && auth) {
    await store.dispatch('app/fetchLevel')
  }
  if ((R.isNil(store.state.app.customerCapability) || R.isEmpty(store.state.app.customerCapability)) && auth) {
    store.dispatch('app/clearCustomer')
    const data = await store.dispatch('app/getCustomerCapabilities')
    if (data.customer_id) {
      const ret = await store.dispatch('app/fetchCustomer')
      if (ret.data.data[0].billing_account_id && store.state.auth.scope === 'domain') {
        await store.dispatch('app/fetchBillAccountInfo', ret.data.data[0].billing_account_id)
      }
    }
  }
  // 登录注释
  // if (store.state.app.level === 0 && !(to.path === '/account' || to.path.startsWith('/account/'))) {
  //   window.location.href = '/account'
  // } else {
  //   next()
  // }
  next()
}
